__turbopack_context__.v({
  "note": "style-module-scss-module__MY1wRG__note",
  "splitWork__content": "style-module-scss-module__MY1wRG__splitWork__content",
  "splitWork__imgWrap": "style-module-scss-module__MY1wRG__splitWork__imgWrap",
  "splitWork__subtitle": "style-module-scss-module__MY1wRG__splitWork__subtitle",
  "splitWork__title": "style-module-scss-module__MY1wRG__splitWork__title",
});
